import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import FormCategoria from './formCategoria'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading';
import CentralLojas from '../../../components/CentralLojas'
import useCentralLojas from '../../../lib/useCentralLojas'
import './style.css';

const CadastroCategoria = () => {

  const colunas = [
    {
      dataField: 'categoria_id',
      text: 'Código'
    },
    {
      dataField: 'categoria',
      text: 'Categoria'
    },
    {
      dataField: 'comissao',
      text: 'Comissão',
      formatter: (cellContent, row) => {
        if (row.comissao) {
          return row.comissao.replace('.', ',')+' %'
        }
        return '0 %'
      }
    },
    {
      dataField: 'desconto',
      text: 'Desconto',
      formatter: (cellContent, row) => {
        if (row.desconto) {
          return row.desconto.replace('.', ',')+' %'
        }
        return '0,00 %'
      }
    }, {
      dataField: 'fidelidade',
      text: 'Fidelidade',
      formatter: (cellContent, row) => {
        if (row.fidelidade === 'S' ) {
          return <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Sim</span></div>
        }else{
          return <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Não</span></div>
        }
      }
    }, {
      dataField: 'central',
      text: 'Central'
    }
  ]

  const { SearchBar }                       = Search
  const [filial_id, setFilial_id]           = useState('')
  const [loading, setLoading]               = useState(true)
  const [modal, setModal]                   = useToggle(false)
  const [categoria_id, setCategoria_id]     = useState('')
  const [listaCategoria, setListaCategoria] = useState([])

  //dados lista categorias
  const listaCategorias = () => {
    let lista = []
    try{
      const retorno = rest.get(rotas.categoria+useCentralLojas.centralLoja().filial_id)
      retorno.then(ret => {
        if (ret.success && ret.success === 'S'){
          lista = ret.lista
          setListaCategoria(lista)
        }
        setLoading(false);
      })
      return (lista)
    }catch(err){
    }
  }

  useEffect(() => {
    listaCategorias()
  }, [useCentralLojas.centralLoja().filial_id]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(modal===false){
      listaCategorias()
    }
  }, [modal])

  //abrir modal do formulario
  const abreModal = (filial_id, categoria_id) => {
    setCategoria_id(categoria_id)
    setFilial_id(filial_id)
    setModal()
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CADASTRO DE CATEGORIAS</CardTitle>
                    </Col>

                    <CentralLojas refresh = {setFilial_id} >
                    </CentralLojas>
                  </Row>
                </CardHeader>

                <CardBody>
                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Categorias</ModalHeader>
                    <FormCategoria
                      filial_id     = {useCentralLojas.centralLoja().filial_id}
                      categoria_id  = {categoria_id}
                      fechaModal    = {setModal}
                    ></FormCategoria>
                  </Modal>

                  <ToolkitProvider
                    search
                    keyField  = "categoria_id"
                    data      = {listaCategoria}
                    columns   = {colunas}
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="3">
                                <Button
                                  outline
                                  className = "m-0 w-100"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  onClick   = {() => abreModal(filial_id,'')}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="9">
                                <SearchBar
                                  placeholder = "Buscar Categoria..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField          = 'categoria_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            pagination        = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            rowStyle          = {{ cursor: "pointer" }}
                            rowEvents         = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(filial_id, row.categoria_id)
                                                  }
                                                }}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default CadastroCategoria
